import { StorageKey } from '@nu-art/thunderstorm-frontend/index';
import { HeaderKey_DeviceId, HeaderKey_TabId } from '@nu-art/thunderstorm-shared/headers';
import { SessionKey_FE } from '../session/ModuleFE_Session.js';
export const SessionKeyFE_Account = new SessionKey_FE('account');
export const StorageKey_DeviceId = new StorageKey(`storage--${HeaderKey_DeviceId}`).withstandDeletion();
export const StorageKey_TabId = new StorageKey(`storage--${HeaderKey_TabId}`, false).withstandDeletion();
export const SessionKey_Account = new SessionKey_FE('account');
//# sourceMappingURL=consts.js.map